<div class="col-md-12 main-heading">
  <div class="d-flex">
    <div class="icon-heading"><img src="assets/images/pages-icon/home_dark.png" class="img-responsive"> </div>
    <div class="caption-heading">Home</div>
    <p style="margin-left: 20px; margin-top:16px; color:red;">{{PASSWORD_WILL_EXPIRE}}</p>
    <!-- <marquee style="font-size: x-large;">The application server needs a schedule maintenance on 30-Apr-2025.</marquee> -->
  </div>
</div>
<div class="col-md-12 tilesWrapper">




  <div class="row">

    <div class="col-md-12 noPaddingR">

      <div class="main">

        <div class="containerMetro boxscroll flex" style="margin-top: -7px;">
          <!-- <div class="item flex-item tilesBg1 smallWidth" >
            <div class="col-md-12 mainHeading">
              <h1>Monitoring</h1>
            </div>
            <a *ngIf="HasViewPermission(ViewAlarmMonitor.rolePermission)" routerLink='/index/liveview'>
              <div class="largetiles tiles">
                <div class="tilesCont">
                  <img src="assets/images/monitoring1/monitor.png" class="img-responsive">
                  <span class="name">Alarm Monitor</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewOccupancy.rolePermission)" routerLink='/index/occupancy'>
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/monitoring1/occupancy.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Occupancy</span>
                  </div>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewParkingStations.rolePermission)" routerLink='/index/parking-stations'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/monitoring1/parking.png" class="img-responsive">
                  <span class="name">Parking Stations</span>
                </div>
              </div>
            </a>
           
            <a *ngIf="HasViewPermission(LiveViewParkfly.rolePermission)" routerLink='/index/parkandfly'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/monitoring1/parking.png" class="img-responsive">
                  <span class="name">Park & Fly</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewFastagReconciliations.rolePermission)" routerLink='/fastag-reconciliation'>
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/configuration/subscription_profile.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Fastag<br />Reconciliation</span>
                  </div>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewANPRViewStreaming.rolePermission)" routerLink='/index/videostreaming'>
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/monitoring1/video_streaming.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">ANPR<br>Video Streaming</span>
                  </div>
                </div>
              </div>
            </a>
          </div>  -->
          <div class="item flex-item tilesBg2 smallWidth">
            <div class="col-md-12 mainHeading">
              <h1>Data Analysis</h1>
            </div>
            <a *ngIf="HasViewPermission(ViewReportCreate.rolePermission)" routerLink='/reports/data-analysis'>
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/reporting/custom_reports.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Report Create</span>
                  </div>
                </div>
              </div>
            </a>
            <!-- <a href="#">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/reporting/reports.png" class="img-responsive">
                  <span class="name">Repository</span>
                </div>
              </div>
            </a>
            <a href="#">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/schedule.png" class="img-responsive">
                  <span class="name">Scheduling</span>
                </div>
              </div>
            </a> -->
          </div>
          <div class="item smallWidth flex-item tilesBg3">
            <div class="col-md-12 mainHeading">
              <h1>Management</h1>
            </div>
            <a *ngIf="HasViewPermission(ViewCustomers.rolePermission)" routerLink="/masters/customer">
              <div class="largetiles tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/customer_group.png" class="img-responsive">
                  <span class="name">Customers</span>
                  <!--<img src="assets/images/configuration/business_contracts.png" class="img-responsive">
                  <span class="name">Contracts</span>-->
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewTimeSlots.rolePermission)" routerLink="/masters/time-slots">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/time_slot_distribution.png" class="img-responsive">
                  <span class="name">Time Slots</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewAccessPolicies.rolePermission)" routerLink='/masters/access-policy'>
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/configuration/access_policy.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Access Policies</span>
                  </div>
                </div>
              </div>
            </a>
            <!-- <a href="#">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/voucher.png" class="img-responsive">
                  <span class="name">Voucher</span>
                </div>
              </div>
            </a>
            <a href="#">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/booking.png" class="img-responsive">
                  <span class="name">Online Booking</span>
                </div>
              </div>
            </a>
            <a href="#">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/alerts.png" class="img-responsive">
                  <span class="name">Alerts</span>
                </div>
              </div>
            </a> -->
            <a *ngIf="HasViewPermission(ViewParksFly.rolePermission)" routerLink="/masters/parknfly">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/media_types.png" class="img-responsive">
                  <span class="name">Parks &amp; Fly</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewGroup.rolePermission)" routerLink='/masters/customergroup'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/account.png" class="img-responsive">
                  <span class="name">Group</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewBlackListWhiteList.rolePermission)"
              routerLink='/index/black-list-white-list'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/white_list.png" class="img-responsive">
                  <span class="name">Blacklist / White List</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewStationGroup.rolePermission)" routerLink='/masters/station-group'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/card_pool.png" class="img-responsive">
                  <span class="name">Station Group</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewProductProfiles.rolePermission)" routerLink="/masters/product-profiles">
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/configuration/subscription_profile.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Product Profiles</span>
                  </div>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewRates.rolePermission)" routerLink='/tariff/rates'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/external_payment.png" class="img-responsive">
                  <span class="name">Rates</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewRatesProfile.rolePermission)" routerLink="/tariff/rate-profile">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/tariff_profile.png" class="img-responsive">
                  <span class="name">Rates Profile</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewUserCategory.rolePermission)" routerLink="/masters/user-category">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/users_management.png" class="img-responsive">
                  <span class="name">User Category</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewDiscount.rolePermission)" routerLink="/masters/discount">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/discounts.png" class="img-responsive">
                  <span class="name">Discount</span>
                </div>
              </div>
            </a>


            <a *ngIf="HasViewPermission(ViewCabGroup.rolePermission)" routerLink='/masters/cabgroup'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/Cab_Group.png" class="img-responsive">
                  <span class="name">Cab Groups</span>
                </div>
              </div>
            </a>

            <a *ngIf="HasViewPermission(ViewCabCards.rolePermission)" routerLink='/masters/cabcards'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/Cab_Cards.png" class="img-responsive">
                  <span class="name">Cab Cards</span>
                </div>
              </div>
            </a>

            <a *ngIf="HasViewPermission(ViewLogFileCnvrtCSV.rolePermission)" routerLink='/index/log-file-cnvrt-csv'>
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/forms_management.png" class="img-responsive">
                  <span class="name">Transaction Log</span>
                </div>
              </div>
            </a>

          </div>
          <div class="item flex-item tilesBg5 smallWidth">
            <div class="col-md-12 mainHeading">
              <h1>System</h1>
            </div>
            <!-- <a href="#">
              <div class="largetiles tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/system_configuration.png" class="img-responsive">
                  <span class="name">System</span>
                </div>
              </div>
            </a>
            <a href="#">
              <div class="tiles widetiles">
                <div class="wide">
                  <div class="wideT">
                    <img src="assets/images/configuration/subscription_profile.png" class="img-responsive">
                  </div>
                  <div class="wideT">
                    <span class="name">Area Count</span>
                  </div>
                </div>
              </div>
            </a> -->
            <a *ngIf="HasViewPermission(ViewDevices.rolePermission)" routerLink="/masters/device">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/configuration/device_apply_condition.png" class="img-responsive">
                  <span class="name">Devices</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewUserOperators.rolePermission)" routerLink="/masters/user">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/reactivate_users.png" class="img-responsive">
                  <span class="name">User / Operators</span>
                </div>
              </div>
            </a>
            <a *ngIf="HasViewPermission(ViewRoles.rolePermission)" routerLink="/masters/role">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/reactivate_users.png" class="img-responsive">
                  <span class="name">Roles</span>
                </div>
              </div>
            </a>

            <!-- <a href="#">
              <div class="tiles widetiles">
                <div class="tilesCont">
                  <img src="assets/images/system/forms_management.png" class="img-responsive">
                  <span class="name">Logs</span>
                </div>
              </div>
            </a> -->
            <!-- <a *ngIf="HasViewPermission(ViewTestPage.rolePermission)" routerLink="/masters/testpage">
              <div class="tiles">
                <div class="tilesCont">
                  <img src="assets/images/system/reactivate_users.png" class="img-responsive">
                  <span class="name">test</span>
                </div>
              </div>
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>